import Script from "next/script"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"
import { getPlainText } from "utilities/getPlainText"
import richText from "utilities/richText"

export default function PracticeAreasFAQSection({ questions }) {
  return (
    <>
      {questions.length
        ? questions.map(({ question, answer, _uid, ...rest }) => (
            <StoryblokVisualEditor story={{ question, answer, _uid, ...rest }} key={_uid}>
              <div className="pb-3 last:pb-0">
                {question ? <h3 className="text-m2 font-semibold pb-3">{question}</h3> : null}
                {richText(answer)}
              </div>
            </StoryblokVisualEditor>
          ))
        : null}
      <Script type="application/ld+json" id="frequently-asked-questions-schema">
        {`{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            ${questions.map(
              ({ question, answer }) => `{
                "@type": "Question",
                  "name": "${question}",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "${getPlainText(answer, { addNewlines: false })}"
                  }
                }`,
            )}
          ]
        }`}
      </Script>
    </>
  )
}
